export const COMMUNITY_LIST_REQUEST = "COMMUNITY/COMMUNITY_LIST_REQUEST";
export const COMMUNITY_LIST_SUCCESS = "COMMUNITY/COMMUNITY_LIST_SUCCESS";
export const COMMUNITY_LIST_FAIL = "COMMUNITY/COMMUNITY_LIST_FAIL";

export const COMMUNITY_DETAIL_REQUEST = "COMMUNITY/COMMUNITY_DETAIL_REQUEST";
export const COMMUNITY_DETAIL_SUCCESS = "COMMUNITY/COMMUNITY_DETAIL_SUCCESS";
export const COMMUNITY_DETAIL_FAIL = "COMMUNITY/COMMUNITY_DETAIL_FAIL";
